import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import StepBackButton from '../../components/atoms/StepBackButton';
import IdentityTable from '../organisms/IdentityTable';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getIdentities } from '../../actions/Identity';
import { getAccounts } from '../../actions/Accounts';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
    // CSV出力ボタンを実装時にコメントアウトを外す
    // float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      statuses: state.identities.statuses
    }),
    dispatch => ({
      actions: bindActionCreators({ getIdentities, getAccounts }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('selected', 'setSelected', []),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('operatorName', 'setOperatorName', 0),
  withState('gochiType', 'setGochiType', 0),
  withState('shopId', 'setShopId', ''),
  withState('status', 'setStatus', 'UNCONFIRMED'),
  withState('shopName', 'setShopName', ''),
  withState('groupName', 'setGroupName', ''),
  withState('phone', 'setPhone', ''),
  withState('address', 'setAddress', ''),
  withState('email', 'setEmail', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        groupName: props.groupName,
        shopName: props.shopName,
        status: props.status,
        phone: props.phone,
        address: props.address,
        email: props.email,
        shopId: props.shopId,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);

      props.actions
        .getIdentities(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        const searchShopId = queryString.parse(this.props.location.search)
          .shopId;
        if (data.payload.role === 'SHOP') {
          this.props.actions
            .getIdentities({
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(identityData => this.props.checkSession(identityData));
          this.props.updateOpenTable(true);
        } else if (searchShopId) {
          await this.props.actions
            .getIdentities({
              shopId: searchShopId,
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(identityData => {
              this.props.checkSession(identityData);
              this.props.setShopName(
                identityData.payload.identities[0].shopName
              );
              this.props.setStatus('');
            });
          this.props.updateOpenTable(true);
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleRedirect,
    handleChangePage,
    account,
    statuses,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    loading,
    openProgress,
    shopName,
    setShopName,
    shopId,
    setShopId,
    groupName,
    setGroupName,
    page,
    status,
    setStatus,
    phone,
    setPhone,
    address,
    setAddress,
    email,
    setEmail
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupName,
      shopName,
      shopId,
      status,
      phone,
      email,
      address,
      page,
      limit: limitNum
    };
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
      // updateLoading(true);
      // updateOpenProgress(true);
      // await actions
      //   .getIdentities(searchKey)
      //   .then(data => {
      //     checkSession(data);
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //     handleChangePage(null, 0);
      //     updateOpenTable(true);
      //   })
      //   .catch(() => {
      //     updateOpenProgress(false);
      //     updateLoading(false);
      //   });
    };
    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            本人確認書類検索
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="運営会社名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={groupName}
                  onChange={e => {
                    setGroupName(e.target.value);
                  }}
                />
              )}
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="住所テキスト検索"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={address}
                  onChange={e => {
                    setAddress(e.target.value);
                  }}
                />
              )}
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="メールアドレス検索"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={email}
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                />
              )}
            </div>
            <div>
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗ID"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopId}
                  onChange={e => {
                    setShopId(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  select
                  label="確認状況"
                  className={classes.textField}
                  margin="normal"
                  value={status}
                  onChange={e => {
                    setStatus(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {statuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              )}
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="電話番号検索"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={phone}
                  onChange={e => {
                    setPhone(e.target.value);
                  }}
                />
              )}
            </div>
            {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
              <div className={classes.buttonLeft}>
                <SearchButton onClickAction={searchAction} />
              </div>
            )}
          </div>
          {openTable && (
            <IdentityTable
              searchKey={searchKey}
              roles={roles}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
            />
          )}
          {isShop && !isReleased && (
            <div>
              <StepBackButton onClickAction={backAction} />
            </div>
          )}
        </Paper>
        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
